import { z } from 'zod';
import { courtAdminstrativeUnitAssignmentSchema } from './ICourtAdminstrativeUnitAssignment';

export const aminstrativeUnitSchema = z.object({
  idAdministrativeUnit: z.number().default(-1),
  AdministrativeUnit: z.string().default(''),
  idFederalState: z.number().default(4),
  activeUnit: z
    .union([z.boolean(), z.number().transform(val => Boolean(val))])
    .transform(val => Boolean(val))
    .default(false),
  // Aus Relationen
  FederalState: z.string().optional(),
});

export const adminstrativeUnitFullObjectSchema = aminstrativeUnitSchema.extend({
  Assignments: courtAdminstrativeUnitAssignmentSchema.array(),
});

export type IAdminstrativeUnit = z.infer<typeof aminstrativeUnitSchema>;
export type IAdminstrativeUnitFullObject = z.infer<
  typeof adminstrativeUnitFullObjectSchema
>;
